import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import {useAuthHeader} from 'react-auth-kit';

const emptyForm = {
   shortName: '',
   displayName: '',
   scoringType: 'score',
   description: '',
   year: new Date().getFullYear(),
   schedule: {
      day: '',
      startTime: '',
      endTime: ''
   }
};

const AddGame = () => {
   const authHeader = useAuthHeader(); 
   const [formData, setFormData] = useState(emptyForm);
   const [status, setStatus] = useState(null); // { text, type: 'success' | 'error' }

   const formatHour = (hour, minute) => {
      const suffix = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
      const paddedMinute = String(minute).padStart(2, '0');
      return `${displayHour}:${paddedMinute} ${suffix}`;
   };

   const generateTimeSlots = () => {
      const times = [];
      for (let hour = 8; hour <= 22; hour++) {
         times.push(formatHour(hour, 0));
         times.push(formatHour(hour, 30));
      }
      return times;
   };

   const handleChange = (e) => {
      const { name, value } = e.target;
      if (['day', 'startTime', 'endTime'].includes(name)) {
         setFormData(prev => ({ ...prev, schedule: { ...prev.schedule, [name]: value } }));
      } else {
         setFormData(prev => ({ ...prev, [name]: name === 'year' ? Number(value) : value }));
      }
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      const { day, startTime, endTime } = formData.schedule;

      if (!day || !startTime || !endTime) {
         setStatus({ text: 'Select a day, start time, and end time.', type: 'error' });
         return;
      }

      const payload = {
         shortName: formData.shortName,
         displayName: formData.displayName,
         scoringType: formData.scoringType,
         description: formData.description,
         year: formData.year,
         schedule: {
            day,
            time: `${startTime} - ${endTime}`
         }
      };

      try {
         const res = await axios.post('/addGame', payload, {
            headers: {Authorization: authHeader()}
         });
         if (res.data.success) {
            setStatus({ text: 'Game added.', type: 'success' });
            setFormData(emptyForm);
         } else {
            setStatus({ text: 'Could not add the game. Check the details and try again.', type: 'error' });
         }
      } catch (err) {
         console.error(err);
         const msg = err.response?.data?.error ?? 'Could not reach the server.';
         setStatus({ text: msg, type: 'error' });
      }
   };

   const timeSlots = generateTimeSlots();

   return (
      <div className="main-style">
         <form className="player-entry-form " onSubmit={handleSubmit}>
            {status && (
               <div className={status.type === 'success' ? 'success-message' : 'error-message'}>
                  {status.text}
               </div>
            )}

            <div className="margin-top-medium">
               <label className="form-label" htmlFor="shortName">Set a Games Short Name:</label>
               <input
                  className="form-input "
                  id="shortName"
                  name="shortName"
                  placeholder="Short Name"
                  value={formData.shortName}
                  onChange={handleChange}
                  required
               />
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="displayName">Set a Games Display Name:</label>
               <input
                  className="form-input "
                  id="displayName"
                  name="displayName"
                  placeholder="Display Name"
                  value={formData.displayName}
                  onChange={handleChange}
                  required
               />
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="scoringType">Select Type of Game Score:</label>
               <select
                  className="form-select "
                  id="scoringType"
                  name="scoringType"
                  value={formData.scoringType}
                  onChange={handleChange}
               >
                  <option value="score">Score</option>
                  <option value="time">Time</option>
                  <option value="rounds">Rounds</option>
                  <option value="distance">Distance</option>
                  <option value="rulerOfTheHill">Ruler of the Hill</option>
               </select>
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="day">Select when the game is scheduled to run:</label>
               <select
                  className="form-select "
                  id="day"
                  name="day"
                  value={formData.schedule.day}
                  onChange={handleChange}
                  required
               >
                  <option value="">Select a Day</option>
                  {['Friday', 'Saturday', 'Sunday'].map(day => (
                     <option key={day} value={day}>{day}</option>
                  ))}
               </select>

               <div className="time-input-container">
                  <select
                     className="form-select"
                     name="startTime"
                     aria-label="Start time"
                     value={formData.schedule.startTime}
                     onChange={handleChange}
                     required
                  >
                     <option value="">Start Time</option>
                     {timeSlots.map(time => (
                        <option key={time} value={time}>{time}</option>
                     ))}
                  </select>

                  <select
                     className="form-select"
                     name="endTime"
                     aria-label="End time"
                     value={formData.schedule.endTime}
                     onChange={handleChange}
                     required
                  >
                     <option value="">End Time</option>
                     {timeSlots.map(time => (
                        <option key={time} value={time}>{time}</option>
                     ))}
                  </select>
               </div>
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="description">Please add the games description:</label>
               <textarea
                  className="form-textarea "
                  id="description"
                  name="description"
                  placeholder="Description"
                  value={formData.description}
                  onChange={handleChange}
                  style={{ height: '100px' }}
               />
            </div>

            <div className="margin-top-small">
               <label className="form-label" htmlFor="year">Please select the year this game is being run:</label>
               <input
                  className="form-input"
                  id="year"
                  type="number"
                  name="year"
                  value={formData.year}
                  onChange={handleChange}
               />
            </div>

            <div className="margin-top-medium">
               <button className="btn-base" type="submit">Add Game</button>
            </div>
         </form>
      </div>
   );
};

export default AddGame;
